import { Zahlungsweise } from '../../../interfaces';

export interface ZahlungsweiseWording {
  /** Standalone adjective, used as the option label in selects and filters. */
  label: string;
  /** Caption above a premium, e.g. "Jährlicher Beitrag". */
  beitragCaption: string;
  /** Period suffix for an amount, e.g. "pro Jahr". */
  proPeriode: string;
}

/**
 * How a Zahlungsweise is written out, in one place. The caption is spelled out per value
 * instead of being suffixed onto `label`: "Jährlich" + "er" only reads as German because all
 * four labels happen to end in "-lich", which a fifth value would not have to.
 */
export const ZAHLUNGSWEISE_WORDING: Record<Zahlungsweise, ZahlungsweiseWording> = {
  [Zahlungsweise.Jaehrlich]: {
    label: 'Jährlich',
    beitragCaption: 'Jährlicher Beitrag',
    proPeriode: 'pro Jahr',
  },
  [Zahlungsweise.Halbjaehrlich]: {
    label: 'Halbjährlich',
    beitragCaption: 'Halbjährlicher Beitrag',
    proPeriode: 'pro Halbjahr',
  },
  [Zahlungsweise.Vierteljaehrlich]: {
    label: 'Vierteljährlich',
    beitragCaption: 'Vierteljährlicher Beitrag',
    proPeriode: 'pro Vierteljahr',
  },
  [Zahlungsweise.Monatlich]: {
    label: 'Monatlich',
    beitragCaption: 'Monatlicher Beitrag',
    proPeriode: 'pro Monat',
  },
};

/**
 * `zahlungsweise` is required on every result, so an unknown value can only come from a
 * contract break. Degrade to a period-less "Beitrag" rather than to the yearly wording —
 * claiming the wrong period is the bug being avoided.
 */
export function beitragWording(zahlungsweise: Zahlungsweise): {
  caption: string;
  proPeriode: string;
} {
  const wording = ZAHLUNGSWEISE_WORDING[zahlungsweise];
  return wording
    ? { caption: wording.beitragCaption, proPeriode: wording.proPeriode }
    : { caption: 'Beitrag', proPeriode: '' };
}
